/* ==========================================================================
   ABC Dentalworks — B&H-style product page behaviour
   Pairs with assets/abcd-pdp-bh.css

   What it does (product template only):
     1. Lifts the product title / vendor / SKU into a full-width header
        above the image + buy box, the way B&H does.
     2. Adds an In Stock status line above the price.
     3. Adds the radiation-servicer credential under the buy buttons on
        X-ray parts. The freight-quote note that used to live in this slot
        was removed on 2026-08-24 — see the comment above isXrayPart.
     4. Builds the tab bar (Overview / Specs / Reviews / Questions) and
        moves the existing description + review widgets into panels.
     5. Builds a Key Specs table from the JSON emitted in layout/theme.liquid.

   Every step is idempotent and guarded — if the markup it expects is not
   there, it skips that step and leaves the page exactly as it was.
   ========================================================================== */
(function () {
  'use strict';

  if (!document.body || document.body.className.indexOf('template-product') === -1) return;

  var PHONE = '727-388-4223';
  var PHONE_HREF = 'tel:7273884223';
  var EMAIL = 'sales@abcdentalworks.com';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  // Spec values come through Liquid's json filter and may carry HTML entities.
  function decode(s) {
    var t = document.createElement('textarea');
    t.innerHTML = String(s == null ? '' : s);
    return t.value;
  }

  /* ---------------------------------------------------------------- 1. header */

  function buildHeader() {
    var list = $('.product-block-list');
    if (!list) return;

    // Prefer the whole product-meta BLOCK (title + vendor/SKU + its trailing
    // separator) so the buy box isn't left with a stray rule at the top.
    var meta =
      $('.product-block-list__item--info [data-block-type="product-meta"]') ||
      $('.product-block-list__item--info .product-meta');
    if (!meta) return;

    var header = $('.bh-product-header');
    if (!header) {
      header = el('div', 'bh-product-header');
      var anchor = list.parentNode && list.parentNode !== document.body ? list.parentNode : list;
      anchor.parentNode.insertBefore(header, anchor);
    }

    // Replace any previously-lifted meta with the freshly rendered one so
    // variant changes (SKU) stay accurate after a partial re-render.
    while (header.firstChild) header.removeChild(header.firstChild);
    header.appendChild(meta);
  }

  /* ------------------------------------------------------- 2. stock + shipping */

  function buildStockLine() {
    var infoList = $('.product-block-list__item--info .product-form__info-list');
    if (!infoList || $('.bh-stock', infoList.parentNode)) return;

    var btn = $('.product-block-list__item--info .product-form__add-button');
    var soldOut =
      !!$('.product-block-list__item--info .product-form__add-button.button--disabled') ||
      /sold out|unavailable/i.test((btn && btn.textContent) || '');

    var line = el('p', 'bh-stock' + (soldOut ? ' bh-stock--out' : ''));
    line.appendChild(el('span', 'bh-stock__dot'));
    line.appendChild(
      document.createTextNode(soldOut ? 'Currently unavailable — call to check stock' : 'In Stock')
    );
    infoList.parentNode.insertBefore(line, infoList);
  }

  // 2026-08-24 (second pass): the buy-box freight note is GONE, on every
  // product. It promised the buyer that we would confirm the exact freight
  // cost with them before their order was processed. The owner reports
  // losing deals to it: it tells a ready buyer that their order stops until
  // a human calls them back. Removed outright rather than reworded — a real
  // shipping figure replaces it once the rate ladder is fixed.
  // DO NOT reinstate any quote-before-purchase promise on the product page.

  // 2026-08-24: radiation-servicer credential, X-RAY PARTS ONLY.
  // The registration is a Florida DOH vendor registration (FAC 64E-5.511,
  // DH Form 1113) — the category that permits installing and servicing
  // radiation machines, as distinct from a facility registering a machine
  // it owns (DH Form 1107).
  //
  // WORDING, owner decision 2026-08-24: the headline must NOT lead with the
  // state. Most buyers are out of state and "Florida-registered" read as a
  // limitation on who could buy. The issuing authority still has to be named
  // in the body — a certificate number with no authority behind it is
  // unverifiable, and there is no national X-ray servicer registration, so an
  // unqualified "registered servicer" would imply one the business does not
  // hold. Issuer stays as provenance; the closing line is a nationwide service
  // offer rather than a compliance warning.
  //
  // The 5 cat:equipment X-ray listings already carry an equivalent section in
  // their own descriptions — isXrayPart is false for them so V-1170 is not
  // printed twice on one page.
  function isXrayPart() {
    if (isXrayPart._cached === undefined) {
      var data = readSpecData();
      isXrayPart._cached = !!(data && data.isXrayPart);
    }
    return isXrayPart._cached;
  }

  function buildXrayNote() {
    if (!isXrayPart()) return;

    var buy = $('.product-block-list__item--info .product-form__buy-buttons');
    if (!buy || $('.bh-xray-note', buy.parentNode)) return;

    var note = el(
      'div',
      'bh-ship-note bh-xray-note',
      '<span aria-hidden="true">&#128737;</span><span><strong>Registered X-ray equipment servicer.</strong> ' +
        'ABC Dentalworks is a state-registered radiation-machine servicer, registered with the Florida ' +
        'Department of Health, Bureau of Radiation Control to install, service, repair and calibrate ' +
        'radiation machines &mdash; Certificate of Registration V-1170. We ship X-ray parts nationwide ' +
        'and can advise on installation requirements in your state. Certificate available on request.</span>'
    );
    buy.parentNode.insertBefore(note, buy.nextSibling);
  }

  /* ------------------------------------------------------------------ 5. specs */

  function readSpecData() {
    var tag = document.getElementById('abcd-pdp-specs');
    if (!tag) return null;
    try {
      return JSON.parse(tag.textContent);
    } catch (e) {
      return null;
    }
  }

  function buildSpecPanel() {
    var data = readSpecData();
    var descTables = $$('.product-block-list__item--description .rte table');
    if (!data && !descTables.length) return null;

    var wrap = el('div', 'bh-specs');

    if (data && data.groups) {
      data.groups.forEach(function (group) {
        var rows = (group.rows || []).filter(function (r) {
          return r && r[1] != null && String(r[1]).trim() !== '';
        });
        if (!rows.length) return;

        var sect = el('div');
        var title = el('h3', 'bh-specs__group-title');
        title.textContent = decode(group.title);
        sect.appendChild(title);

        var table = el('table', 'bh-specs__table');
        var tbody = el('tbody');
        rows.forEach(function (r) {
          var tr = el('tr');
          var th = el('th');
          th.textContent = decode(r[0]);
          var td = el('td');
          td.textContent = decode(r[1]);
          tr.appendChild(th);
          tr.appendChild(td);
          tbody.appendChild(tr);
        });
        table.appendChild(tbody);
        sect.appendChild(table);
        wrap.appendChild(sect);
      });
    }

    // Any table the merchandiser put in the description belongs in Specs.
    descTables.forEach(function (t) {
      var block = el('div');
      block.appendChild(t);
      wrap.appendChild(block);
    });

    return wrap.children.length ? wrap : null;
  }

  /* ------------------------------------------------------------ 4. tab assembly */

  function findReviewWidget() {
    return (
      $('#shopify-product-reviews') ||
      $('.jdgm-rev-widg') ||
      $('.spr-container') ||
      $('.okeReviews') ||
      $('.yotpo-reviews-main-widget') ||
      null
    );
  }

  function buildQuestionsPanel() {
    var panel = el('div');
    panel.appendChild(
      el(
        'p',
        null,
        'Questions about fitment, condition, installation or shipping? You get a technician, not a call centre.'
      )
    );

    var rail = el('div', 'bh-expert');

    var call = el('a', 'bh-expert__item');
    call.href = PHONE_HREF;
    call.innerHTML =
      '<span class="bh-expert__icon" aria-hidden="true">&#9742;</span>' +
      '<span class="bh-expert__label"><strong>' +
      PHONE +
      '</strong><span>Talk to a technician</span></span>';
    rail.appendChild(call);

    var email = el('a', 'bh-expert__item');
    email.href = 'mailto:' + EMAIL;
    email.innerHTML =
      '<span class="bh-expert__icon" aria-hidden="true">&#9993;</span>' +
      '<span class="bh-expert__label"><strong>Email us</strong><span>' +
      EMAIL +
      '</span></span>';
    rail.appendChild(email);

    var ask = el('button', 'bh-expert__item');
    ask.type = 'button';
    ask.innerHTML =
      '<span class="bh-expert__icon" aria-hidden="true">&#128172;</span>' +
      '<span class="bh-expert__label"><strong>Ask about this item</strong><span>We reply same business day</span></span>';
    ask.addEventListener('click', function () {
      var trigger = document.getElementById('core-ask-btn');
      if (trigger) {
        trigger.click();
      } else if (window.ABCContactDrawer && typeof window.ABCContactDrawer.open === 'function') {
        window.ABCContactDrawer.open();
      } else {
        window.location.href = PHONE_HREF;
      }
    });
    rail.appendChild(ask);

    panel.appendChild(rail);
    return panel;
  }

  function buildTabs() {
    if ($('.bh-tabs')) return;

    var list = $('.product-block-list');
    if (!list) return;

    var descItem = $('.product-block-list__item--description');
    var specPanel = buildSpecPanel();
    var reviewWidget = findReviewWidget();

    var tabs = [];

    if (descItem) tabs.push({ id: 'overview', label: 'Overview', node: descItem });
    if (specPanel) tabs.push({ id: 'specs', label: 'Specs', node: specPanel });
    if (reviewWidget) tabs.push({ id: 'reviews', label: 'Reviews', node: reviewWidget });
    tabs.push({ id: 'questions', label: 'Questions', node: buildQuestionsPanel() });

    // A tab bar with a single tab is just a heading — not worth the chrome.
    if (tabs.length < 2) return;

    var root = el('div', 'bh-tabs');
    var nav = el('div', 'bh-tabs__nav');
    nav.setAttribute('role', 'tablist');
    var panels = el('div', 'bh-tabs__panels');

    function select(idx, focus) {
      $$('.bh-tabs__tab', nav).forEach(function (b, i) {
        b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        b.tabIndex = i === idx ? 0 : -1;
        if (i === idx && focus) b.focus();
      });
      $$('.bh-tabs__panel', panels).forEach(function (p, i) {
        p.hidden = i !== idx;
      });
    }

    tabs.forEach(function (t, i) {
      var btn = el('button', 'bh-tabs__tab', t.label);
      btn.type = 'button';
      btn.id = 'bh-tab-' + t.id;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-controls', 'bh-panel-' + t.id);
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.tabIndex = i === 0 ? 0 : -1;
      nav.appendChild(btn);

      var panel = el('div', 'bh-tabs__panel');
      panel.id = 'bh-panel-' + t.id;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', 'bh-tab-' + t.id);
      if (i !== 0) panel.hidden = true;
      panel.appendChild(t.node);
      panels.appendChild(panel);

      btn.addEventListener('click', function () {
        select(i);
      });
      btn.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        select((i + d + tabs.length) % tabs.length, true);
      });
    });

    root.appendChild(nav);
    root.appendChild(panels);

    // Warehouse lays .product-block-list out in CSS multi-columns, so anything
    // appended inside it gets squeezed into one column. Append to the page
    // container instead (the same parent the lifted header sits in) so the tab
    // block spans the full width, directly under the image + buy box.
    var header = $('.bh-product-header');
    var host = header ? header.parentNode : list.parentNode && list.parentNode.parentNode;
    if (host && host !== document.body && host.nodeType === 1) {
      host.appendChild(root);
    } else {
      list.parentNode.insertBefore(root, list.nextSibling);
    }
  }

  /* ------------------------------------------------------------------- runner */

  function enhance() {
    try {
      buildHeader();
      buildStockLine();
      buildXrayNote();
      buildTabs();
    } catch (e) {
      if (window.console && console.warn) console.warn('[abcd-pdp-bh]', e);
    }
  }

  function boot() {
    enhance();

    // The theme re-renders the info column on variant change; re-apply the
    // header lift and buy-box additions when that happens.
    var target = $('.product-block-list');
    if (!target || !window.MutationObserver) return;

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        try {
          buildHeader();
          buildStockLine();
          buildXrayNote();
        } catch (e) {
          /* no-op */
        }
      });
    }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();